module.exports = __webpack_public_path__ + "img/check_img.65dbd5ee.png";